import { render, staticRenderFns } from "./BtnFiltroProyecto.vue?vue&type=template&id=3737b1da&"
import script from "./BtnFiltroProyecto.vue?vue&type=script&lang=js&"
export * from "./BtnFiltroProyecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports